export class Categoria{
    id: number;
    name: string;
    icon: string;
}